import {
  BorderGridContainer,
  Button,
  Clickable,
  GridBox,
  H1,
  H2,
  H3,
  List,
  P,
  Section,
  Strong,
  Wrapper,
} from '@ahmdigital/ui';

import constants from '../../../../ahm-constants';
import Head from '../../../../../utils/head';
import styles from './styles.module.sass';

const CASH_BOOST_PDS = `${constants.URLS.SALES.CASH_BOOST}/pds`;

const ClaimPage = () => (
  <>
    <Head titleTemplate="%s - ahm">
      <title>How to claim - ahm Cash Boost</title>
      <meta name="description" content="How to make an ahm Cash Boost claim" />
    </Head>
    <BorderGridContainer hideBorderTop>
      <GridBox padding="0">
        <Section className={styles.content}>
          <Wrapper className={styles.wrapper}>
            <Section variant={['paddingTopSpacerNone', 'paddingBottomSpacerNone', 'marginBottomSpacer8']}>
              <H1 looksLike="h5" variant="marginBottomSpacer11">
                Cash Boost claim
              </H1>
              <H2 looksLike="h3" variant="marginBottomSpacer10">
                How to make a claim
              </H2>
              <P>Follow these easy steps to submit your claim:</P>
            </Section>

            <Section variant={['paddingTopSpacerNone', 'paddingBottomSpacerNone', 'marginBottomSpacer8']}>
              <H3 looksLike="h4" variant="marginBottomSpacer9">
                Step 1: Check you’re eligible for a claim
              </H3>
              <P variant="marginBottomSpacer10">Before you submit a claim, please make sure that:</P>
              <List className={styles.list}>
                <li>
                  You are claiming for one of the listed <Strong>specified critical illness events</Strong> covered
                  under your Cash Boost policy.
                </li>
                <li>
                  Your Cash Boost policy, and cover for the insured person for which the claim is related to, was active
                  at the time the <Strong>specified critical illness event</Strong> occurred.
                </li>
                <li>
                  You understand that claims are assessed based on the terms of your Cash Boost policy, as outlined in
                  the <Clickable to={CASH_BOOST_PDS}>Product Disclosure Statement (PDS)</Clickable>. The PDS explains
                  when a benefit may be paid and when it won’t be.
                </li>
              </List>

              <P variant="marginTopSpacer10">
                For claims relating to{' '}
                <Strong>
                  cancer of specified severity, coronary artery bypass graft surgery, heart attack of specified
                  severity, kidney failure (end stage), major organ transplant
                </Strong>{' '}
                or <Strong>stroke:</Strong>
              </P>

              <List className={styles.list}>
                <li>
                  A claim can’t be paid if the event first occurred, first showed symptoms, or was diagnosed{' '}
                  <Strong>within the qualifying period</Strong>. The qualifying period is generally the 180 day period
                  following cover starting for the insured person under your Cash Boost policy.
                </li>
              </List>

              <P variant="marginTopSpacer10">
                For claims relating to an <Strong>accident resulting in surgery</Strong> or <Strong>burns:</Strong>
              </P>

              <List className={styles.list}>
                <li>
                  A claim can’t be paid if the accident or burns occurred{' '}
                  <Strong>before the cover start date for the insured person</Strong> under your Cash Boost policy, even
                  if treatment or surgery happens later.
                </li>
              </List>
            </Section>

            <Section variant={['paddingTopSpacerNone', 'paddingBottomSpacerNone', 'marginBottomSpacer8']}>
              <H3 looksLike="h4" variant="marginBottomSpacer9">
                Step 2: Complete the claim form
              </H3>
              <P variant="marginBottomSpacer9">
                Provide details of your claim and attach any medical evidence you already have, such as medical or
                hospital records.
              </P>
              <Button
                icon={{ name: 'external-link-light', position: 'right' }}
                to={constants.URLS.THIRD_PARTY.CASH_BOOST_CLAIM}
                variant="primary"
              >
                Claim form
              </Button>
            </Section>

            <Section variant={['paddingTopSpacerNone', 'paddingBottomSpacerNone', 'marginBottomSpacer8']}>
              <H3 looksLike="h4" variant="marginBottomSpacer9">
                Step 3: Claim assessment
              </H3>
              <P variant="marginBottomSpacer11">
                Your claim will be sent to Zurich, the insurer of Cash Boost, who will assess it and may ask for any
                additional information if needed.
              </P>
              <P variant="marginBottomSpacer11">
                We’ll always work with you to make sure you understand what’s needed and why.
              </P>
              <P variant="marginBottomSpacer11">
                Claims are subject to all policy terms, conditions and exclusions set out in the PDS.
              </P>
              <P variant="marginBottomSpacer11">
                For the full details on what we might ask for and how claims are assessed, please refer to the{' '}
                <Clickable to={CASH_BOOST_PDS}>Cash Boost PDS.</Clickable>
              </P>
            </Section>
          </Wrapper>
        </Section>
      </GridBox>
    </BorderGridContainer>
  </>
);

export default ClaimPage;
